const config = {
	lang: "th"
}

export default config